/**
 * elementui的默认颜色公式，顺序很重要，最好不要动，否则会影响框架的主题！！！！！
 * */
const formulaColor = {
  'shade-1': 'color(primary shade(10%))',
  'light-1': 'color(primary tint(10%))',
  'light-2': 'color(primary tint(20%))',
  'light-3': 'color(primary tint(30%))',
  'light-4': 'color(primary tint(40%))',
  'light-5': 'color(primary tint(50%))',
  'light-6': 'color(primary tint(60%))',
  'light-7': 'color(primary tint(70%))',
  'light-8': 'color(primary tint(80%))',
  'light-9': 'color(primary tint(90%))'
}

export default formulaColor



// WEBPACK FOOTER //
// ./src/plugins/theme/elementFormula.js